<div class="blog-modal">
    <div class="blog-modal-body">
        <ng-content></ng-content>
    </div>
</div>
<div class="blog-modal-background"></div>
